module.exports = __webpack_public_path__ + "assets/LineBetweenPointsDetailed.e057780752f409e5637e27a358bb582b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LineBetweenPointsDetailed.png
// module id = 536
// module chunks = 0